import React from 'react';
import {Container} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faPhone, faGears, faCircleCheck, faChartLine
} from '@fortawesome/free-solid-svg-icons';

const steps = [
    {
        icon: faPhone,
        when: 'Week 0',
        title: 'A conversation',
        desc: 'One hour. We agree the decision worth automating first.'
    },
    {
        icon: faGears,
        when: 'Weeks 1–3',
        title: 'We build',
        desc: 'Working pilot on your documents. Your experts shape it as it takes shape.'
    },
    {
        icon: faCircleCheck,
        when: 'Week 4',
        title: 'You see it run',
        desc: 'Live system against real cases. Stakeholders evaluate, not a slide deck.'
    },
    {
        icon: faChartLine,
        when: 'From there',
        title: 'It grows',
        desc: 'New domains plug in alongside the first. Each one ships faster than the last.'
    }
];

const ProcessSection = () => (
    <section className="process-timeline-section">
        <Container>
            <div className="text-center mb-5">
                <div className="section-label">The Engagement</div>
                <h2>From first call to working system, in weeks, not years.</h2>
                <p className="section-intro">
                    No multi-year programme. No slide-deck-only deliverables.
                    A clear path from conversation to a pilot your team can use.
                </p>
            </div>

            <div className="process-timeline">
                <div className="process-timeline-track" aria-hidden="true"/>
                {steps.map((s, i) => (
                    <div key={i} className="process-timeline-step">
                        <div className="process-timeline-marker">
                            <FontAwesomeIcon icon={s.icon}/>
                        </div>
                        <div className="process-timeline-when">{s.when}</div>
                        <h4 className="process-timeline-title">{s.title}</h4>
                        <p className="process-timeline-desc">{s.desc}</p>
                    </div>
                ))}
            </div>
        </Container>
    </section>
);

export default ProcessSection;